import { Directive, EventEmitter, Input, Output } from '@angular/core';

@Directive()
export class DateRangeStatus {
  @Input() startDate: any;
  @Input() comingSoonDate: any;
  @Output() itemStart: EventEmitter<any> = new EventEmitter();
}
